import './static-hero.css'
import heroImg from '../../assets/img/about/asset 1.png'

const StaticHero = () => {
	return (
		<section className="static-hero">
			<div className="container">
				<div className="hero-title">
					<h1>Über uns</h1>
					<ul>
						<li>Home</li>
						<li>Über uns</li>
					</ul>
				</div>
				<div className="img-holder">
					<img src={heroImg} alt="hero-img" />
				</div>
			</div>
		</section>
	)
}

export default StaticHero
